const React = require('react');
const AccountHolderFields = require('../AccountHolderFields');
const DirectorFields = require('../DirectorFields');

module.exports = ({activeUserId, formCtx}) => {
  const data = (formCtx.state || {}).data || {};
  const isDirector = data.holder_is_director;

  return (
    <>
      <AccountHolderFields activeUserId={activeUserId} formCtx={formCtx} />
      {!isDirector && (
        <div className="mt50">
          <DirectorFields activeUserId={activeUserId} formCtx={formCtx} />
        </div>
      )}
    </>
  )
}
